module.exports = __webpack_public_path__ + "img/bm2.908d9e8a.png";